import React, {useEffect, useState} from 'react';
import { Button, Form, Col, Row, DatePicker, Radio, Typography, Input, InputNumber, Select, Table, message, Modal, Checkbox } from 'antd';
import '../App.css';
import 'antd/dist/antd.css'; 
import 'moment/locale/es';
import locale from 'antd/es/date-picker/locale/es_ES';
import { PlusOutlined, EditOutlined, DeleteOutlined, SendOutlined, InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios'; //adri
import { v4 as uuidv4 } from 'uuid';
import {Helmet} from "react-helmet";
//<script type="text/javascript" src="../js/iframeResizer.contentWindow.min.js"></script> 

const {Item} = Form;

function App() {

  
  // INI - VARIABLES Y ESTADOS

  const {Title, Text}=Typography;
  const {Option}=Select;

  const columns=[
    {
      title:"Categoria",
      dataIndex:"letra",
      key:"letra"
    },
    {
      title:"Años",
      dataIndex:"anos",
      key:"anos"
    },
    {
      title:"Meses",
      dataIndex:"meses",
      key:"meses"
    },
    {
      title:"",      
      key:"acciones",
      render: fila => (
                          <> 
                            {/*<Button type="primary" icon = {<EditOutlined/>}   onClick = {()=>seleccionarRegistro(fila, "Editar"  )}>Editar  </Button> {"   "} */}
                            <Button type="danger"  icon = {<DeleteOutlined/>} onClick = {()=>seleccionarRegistro(fila, "Eliminar")}>Eliminar</Button> 
                          </>
      ),
    },
  ];

  const seleccionarRegistro = (registro,caso) => {
    setRegistro(registro);
    console.log("EDITAR - fila seleccionada");
    console.log(registro);
    console.log("caso");
    console.log(caso);
    (caso ==="Editar")? abrirCerrarModalEditar():abrirCerrarModalEliminar();
  }
    
  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 9 },
      md: { span: 7 }, 
      lg: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const layoutTable = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  
    const layoutModal = {
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
    };    

    const [edadRetiro, setEdadRetiro] = useState();
    const [aniosAporteAux, setAniosAporteAux] = useState();
    const [edadRetiroM, setEdadRetiroM] = useState();
    const [edadRetiroF, seteEdadRetiroF] = useState();
    const [minimoAniosAporte, setMinimoAniosAporte] = useState();
 

    const [infoEM10, setInfoEM10] = useState();
    const [infoRM10, setInfoRM10] = useState();
    const [infoERet, setInfoERet] = useState();
    const [infoUltCat, setInfoUltCat] = useState();

    const dateFormat = 'DD/MM/YYYY';
    
    const [aniosAporte, setAniosAporte] = useState()    
    const [aniosIAporte, setAniosIAporte] = useState()
    const [aniosAAporte, setAniosAAporte] = useState()

    const [mesesAporte, setMesesAporte ] = useState()
    const [mesesIAporte, setMesesIAporte] = useState()
    const [mesesAAporte, setMesesAAporte] = useState()

    const [loading, setLoading] = useState(false)
    const [regimen, setRegimen] = useState()
    const [sexo, setSexo] = useState()
    const [edad, setEdad] = useState()
    const [letra, setCategoria] = useState()
	const [categoriaValue, setCategoriaValue] = useState()													  
    const [anos, setAnos] = useState()
    const [meses, setMeses] = useState()
    const [ultimacategoria, setUltimacategoria] = useState()
    const [modalEditar, setModalEditar] = useState(false);    
    const [modalEliminar, setModalEliminar] = useState(false);  
    const [data, setData] = useState([])
    const [modalInsertar, setModalInsertar] = useState(false);
    const [nacimiento, setNacimiento] = useState();
    const [fCalc, setFCalc] = useState();
    const [form] = Form.useForm();
    const [registro, setRegistro] = useState({
      id:"",
      letra:"",
      anos:0,
      ultimacategoria:false,
      meses:0,
	  categoriaValue: ""
  })
  
    useEffect(()=>{
      capturarInfo();       
  },[])
    const [errorTable,setErrorTable] = useState(false);
    const [errorTotales,setErrorTotales] = useState(false);
    const [errorCoincidentes,setErrorCoincidentes] = useState(false);
    const [errorCoincidentes2,setErrorCoincidentes2] = useState(false);
    const [errorCoincidentes3,setErrorCoincidentes3] = useState(false);
  let sumaMesesAuto = 0;
  let totalMeses = 0;
  let itemAnos = 0;
  let itemMeses = 0;    
	let ingresosMenos10 = "Ingresos a los " + (edad - 10) + " años"  
  let faltante = 0;
  let edadRetiroAux;  
  let hayCat1 = false;
  let hayCat2 = false;
  let hayCat3 = false;
  let hayCat4 = false;
  let hayCat5 = false;

  let hayCatA = false;
  let hayCatB = false;
  let hayCatC = false;
  let hayCatD = false;
  let hayCatE = false;
  let hayCatF = false;
  let hayCatG = false;
  let hayCatH = false;
  let hayCatI = false;
  let hayCatJ = false;
  let hayCatW = false;
  // let edadRetiroM = 65;
    // let edadRetiroF = 60;
    // let minimoAniosAporte = 30;
    // FIN - VARIABLES Y ESTADOS


    // INI - FUNCIONES

    const formSuccess=(datos) => {        
        //////////////adri llamar api/////////////////////////////
        const baseUrl = 'https://a3l.com.ar/Cotizador/Backend/consulta'; // "http://localhost:3900/jubilacion/consulta"
          
        //POST - INSERTAR
        const peticionPost = async() => {
            setErrorTable(false)
            setErrorTotales(false)
            setErrorCoincidentes2(false)
            setErrorCoincidentes3(false)
            setErrorCoincidentes(false)
            let OK = true;
            //delete artista.id;
            console.log("hola viteeeee " + JSON.stringify(datos));
            // if (datos.sexo.toUpperCase() == 'M'){
            //   datos.edadRetiro = edadRetiroM;
            // }
            // else{
            //   datos.edadRetiro = edadRetiroF;
            // }
            datos.edadRetiro = edadRetiro;
            if(datos.regimen == "auto" || datos.regimen == "ambos" ){
              sumaMesesAuto = 0;
              if(datos.regimen == "auto"){
                datos.aniosAporteRelacion = 0
                datos.mesesAporteRelacion = 0
                datos.aniosAporteCoincidentes = 0
                datos.mesesAporteCoincidentes = 0
              }
              else{
                var anosRel;
                var mesesRel;
                var anosTot;
                var mesesTot;
                var anosCoin;
                var mesesCoin;
                if(typeof datos.aniosAporteRelacion == 'undefined'){
                  anosRel = 0;
                }
                else{
                  anosRel = parseInt(datos.aniosAporteRelacion)
                }   
                if(typeof datos.mesesAporteRelacion == 'undefined'){
                  mesesRel = 0;
                }
                else{
                  mesesRel = parseInt(datos.mesesAporteRelacion)
                }                 
                // /////////////////////
                // if(typeof datos.aniosAporteTotales == 'undefined'){
                //   anosTot = 0;
                // }
                // else{
                //   anosTot = parseInt(datos.aniosAporteTotales)
                // }   
                // if(typeof datos.mesesAporteTotales == 'undefined'){
                //   mesesTot = 0;
                // }
                // else{
                //   mesesTot = parseInt(datos.mesesAporteTotales)
                // }  
                // ////////////

                if(typeof datos.aniosAporteCoincidentes == 'undefined'){
                  anosCoin = 0;
                }
                else{
                  anosCoin = parseInt(datos.aniosAporteCoincidentes)
                }   
                if(typeof datos.mesesAporteCoincidentes == 'undefined'){
                  mesesCoin = 0;
                }
                else{
                  mesesCoin = parseInt(datos.mesesAporteCoincidentes)
                }                 

                // if(((anosRel * 12 ) + mesesRel) >  ((anosTot * 12 ) + mesesTot)  ) {
                //   setErrorTotales(true);
                //   OK = false;
                // }
           
              }
              totalMeses = 0;
              itemAnos = 0;
              itemMeses = 0;
              let unicaCat = "";
              data.forEach(function (item) {
                unicaCat = item.categoriaValue;
                console.log("item.meses " + item.meses + " anos " + item.anos)
                if(typeof item.anos == 'undefined' || isNaN(parseInt(item.anos))){
                  itemAnos = 0;
                }
                else{
                  itemAnos = parseInt(item.anos)
                  console.log("asigna anos " + itemAnos)
                }
                if(typeof item.meses == 'undefined' || isNaN(parseInt(item.meses))){
                  itemMeses = 0;
                }
                else{
                  itemMeses = parseInt(item.meses)
                  console.log("asigna meses " + itemMeses)
                }                
                sumaMesesAuto += itemMeses+ (itemAnos * 12);
                totalMeses = parseInt(itemAnos) + parseInt(itemMeses);
                console.log("itemanos " + itemAnos + " itemMeses " + itemMeses)
                console.log("totalmeses " + totalMeses + " sumaMesesAuto " + sumaMesesAuto)
                console.log("isNaN(totalMeses) " + isNaN(totalMeses))
                if(totalMeses  <= 0 || isNaN(totalMeses)){
                  OK = false;
                  setErrorTable(true)
                  console.log(" setErrorTable(true)")
                }
              });
              console.log("data len " + data.length)
              if(data.length == 1){
                // datos.ultimaCate = unicaCat;
              }
              else{
                if(data.length == 0){
                  OK = false;
                  setErrorTable(true)     
                  console.log("no tiene nada")            
                }
              }
              if(datos.regimen == "auto"){
                let sumaAniosAuto = parseInt(sumaMesesAuto / 12);
                sumaMesesAuto = sumaMesesAuto % 12;
                datos.aniosAporteTotales = sumaAniosAuto;
                datos.mesesAporteTotales = sumaMesesAuto;
              }
              else{

                let sumaAniosAuto = parseInt(sumaMesesAuto / 12);
                let auxMesesAuto = sumaMesesAuto % 12;
                if( data.length > 0 && ((sumaAniosAuto * 12 ) + auxMesesAuto) <  ((anosCoin * 12 ) + mesesCoin)  ){ 
                  setErrorCoincidentes3(true);
                  OK = false;
                } 

                else{
                  sumaMesesAuto += mesesRel
                  sumaMesesAuto += anosRel * 12
                  sumaMesesAuto -= mesesCoin
                  sumaMesesAuto -= anosCoin * 12

                  let sumaAniosTot = parseInt(sumaMesesAuto / 12);
                  let sumaMesesTot = sumaMesesAuto % 12

                  datos.aniosAporteTotales = sumaAniosTot
                  datos.mesesAporteTotales = sumaMesesTot

                  //sumaMesesAuto tiene la suma de los meses totales, rela + auto - simultaneos,  (a pesar de tener "Auto" en el nombre)
                  if(((anosCoin * 12 ) + mesesCoin) >  ((sumaAniosTot * 12 ) + sumaMesesTot)  ){ 
                    setErrorCoincidentes2(true);
                    OK = false;
                  }    
                  if(((anosRel * 12 ) + mesesRel) ==  ((sumaAniosTot * 12 ) + sumaMesesTot)  && (anosCoin + mesesCoin == 0)){ 
                    setErrorCoincidentes(true);
                    OK = false;
                  }
                }

              }
            }
            else{
                if(datos.regimen == "depe"){
                  datos.aniosAporteRelacion = datos.aniosAporteTotales
                  datos.mesesAporteRelacion = datos.mesesAporteTotales
                  datos.aniosAporteCoincidentes = 0
                  datos.mesesAporteCoincidentes = 0                  
                }
            }
            datos.autDetalle = data;
            
            console.log("tabla:")
            console.log(JSON.stringify(data));
            if(OK){
            setLoading(true)
            await axios.post(baseUrl,datos)
            .then(response=>{
                console.log("respuesta: " + JSON.stringify(response));
                console.log("respuesta.data.status " + response.data.status)
                if(response.data.status === 'error'){
                  message.error("UPS! HA OCURRIDO UN ERROR! " + response.data.message + " / " + response.data.errMsg);
                  console.log("acà vamos a llamar a la grabaciòn de un log...");
                  setLoading(false);
                }
                else{
                  setLoading(false);
                  window.location.href = "https://a3l.com.ar/buentrabajo";                  
                }

            }).catch(error=>{
                // console.log("error " + error);
                console.log("error " + JSON.stringify(error));
                setLoading(false);            
            })
          }
        }    
        peticionPost();
        /////////////fin adri llamar api////////////////////////////////////////////                    
      };

    const formFailed=(error) =>  { 
      message.error('Por favor ingrese todos los datos requeridos'); 
      console.log("Error",error); 
    };

    const onChange = (value) => {
      setRegimen(value); 
      calcularRetiro(null, null, null, null, null, value, null, null, null, null)      
    }

    function calculadoraDeAnios(e){
      setSexo(e.target.value);
      // if(e.target.value.toUpperCase() == 'M'){
      //   console.log("************SETEDADRETIRO SEXO 270 " + edadRetiroM)
      //   setEdadRetiro(edadRetiroM)
      // }
      // else{
      //   console.log("************SETEDADRETIRO SEXO 274 " + edadRetiroF)
      //   setEdadRetiro(edadRetiroF)
      // }
      calcularRetiro(null, null, null, e.target.value, null, null, null, null, null, null)  
    }    

    function cumple (date) {
      let fechaDeNacimiento = date;
      let hoy = fechaCalculo;//let hoy = new Date(); asdf
      let edadAux = parseInt((hoy - fechaDeNacimiento) / (1000*60*60*24*365));      
      setEdad(edadAux );
      setNacimiento(date);
      //acà tengo que agregar una condición de que si es autonomo y tiene lleno algo. Además tengo que hacer que llame a calcularRetiro cuando elimina o agrega categoría
      sumaMesesAuto = 0;
      itemAnos = 0;
      itemMeses = 0;
      if(regimen == "auto"){
        data.forEach(function (item) {
          if(typeof item.anos == 'undefined' || isNaN(parseInt(item.anos))){
            itemAnos = 0;
          }
          else{
            itemAnos = parseInt(item.anos)
          }
          if(typeof item.meses == 'undefined' || isNaN(parseInt(item.meses))){
            itemMeses = 0;
          }
          else{
            itemMeses = parseInt(item.meses)
          }                
          sumaMesesAuto += itemMeses+ (itemAnos * 12);
        }); 
      }
      if(sumaMesesAuto > 0 || (aniosAporte && typeof aniosAporte != "undefined") || (mesesAporte && typeof mesesAporte != "undefined") && (sexo && typeof sexo != "undefined") ){ 
        calcularRetiro(aniosAporte, mesesAporte, edadAux, null, null, null, null, null, null, null)
      }
    }  

    function fechaCalculo (fCalc){
      setFCalc(fCalc)
      console.log("la fecha de calculo es: ")
      console.log(fCalc)
    }
    
    function calcularRetiro(aValue, mValue, eValue, sValue, dataAux, regiValue, aDepeValue, mDepeValue, aCoinValue, mCoinValue){
      let aDepe_aux = 0;
      if(aDepeValue && typeof aDepeValue != "undefined"){
        aDepe_aux = aDepeValue;
      }
      else{
        if(aniosIAporte  && typeof aniosIAporte != "undefined"){
          aDepe_aux = aniosIAporte
        }
        else{
          aDepe_aux = 0
        }
      }
      let mDepe_aux = 0;
      if(mDepeValue && typeof mDepeValue != "undefined"){
        mDepe_aux = mDepeValue;
      }
      else{
        if(mesesIAporte  && typeof mesesIAporte != "undefined"){
          mDepe_aux = mesesIAporte
        }
        else{
          mDepe_aux = 0
        }
      }
      let aCoin_aux = 0;
      if(aCoinValue && typeof aCoinValue != "undefined"){
        aCoin_aux = aCoinValue;
      }
      else{
        if(aniosAAporte  && typeof aniosAAporte != "undefined"){
          aCoin_aux = aniosAAporte
        }
        else{
          aCoin_aux = 0;
        }
      }
      let mCoin_aux = 0;
      if(mCoinValue && typeof mCoinValue != "undefined"){
        mCoin_aux = mCoinValue;
      }
      else{
        if(mesesAAporte  && typeof mesesAAporte != "undefined"){
          mCoin_aux = mesesAAporte
        }
        else{
          mCoin_aux = 0
        }
      }

      let regi_aux = "";
      if(regiValue && typeof regiValue != "undefined"){
        regi_aux = regiValue;
      }
      else{
        regi_aux = regimen;
      }
      let sexo_aux = "";
      if(sValue && typeof sValue != "undefined"){
        sexo_aux = sValue;
      }
      else{
        if(sexo && typeof sexo != "undefined"){
          sexo_aux = sexo;
        }
        else{
          sexo_aux = 'm'
        }
        
      }
      let aniosAporteAux_ = 0;
      // if(regimen != "auto"){
      if(regi_aux == "depe"){
        if((eValue && typeof eValue != "undefined") && (!sValue || typeof sValue == "undefined")){
          aniosAporteAux_ = aValue;
        }
        else{
          if(aValue && typeof aValue != "undefined"){
            aniosAporteAux_ = aValue;
          }
          else{
            if((mValue && typeof mValue != "undefined") || (sValue && typeof sValue != "undefined") ){
              aniosAporteAux_ = aniosAporte;
            }
          }
        }
        console.log("mvalue " + mValue + " aniosAporteAux_ " + aniosAporteAux_)
        
        if(eValue && typeof eValue != "undefined"){
          if(mValue && typeof mValue != "undefined" && mValue > 6){
            aniosAporteAux_ += 1
            console.log("mvalue xx ")
          }        
        }
        else{
          if(mValue && typeof mValue != "undefined" && mValue > 6){
            aniosAporteAux_ += 1
            console.log("mvalue xx ")
          }
          else{
              if((aValue && typeof aValue != "undefined") || (sValue && typeof sValue != "undefined")  ){
                if(mesesAporte && typeof mesesAporte != "undefined" && mesesAporte > 6){
                  aniosAporteAux_ += 1
                  console.log("mvalue yy ")
                }       
              }
          }
        }
      }
      else{
        sumaMesesAuto = 0;
        itemAnos = 0;
        itemMeses = 0;
        console.log("hola sumaMesesAuto " + sumaMesesAuto)
        var dataAuto;
        if(dataAux && typeof dataAux != "undefined"){
          dataAuto = dataAux;
        }
        else{
          dataAuto = data;
        }
        dataAuto.forEach(function (item) {
          console.log("item.meses " + item.meses + " anos " + item.anos)
          if(typeof item.anos == 'undefined' || isNaN(parseInt(item.anos))){
            itemAnos = 0;
          }
          else{
            itemAnos = parseInt(item.anos)
            console.log("asigna anos " + itemAnos)
          }
          if(typeof item.meses == 'undefined' || isNaN(parseInt(item.meses))){
            itemMeses = 0;
          }
          else{
            itemMeses = parseInt(item.meses)
            console.log("asigna meses " + itemMeses)
          }                
          sumaMesesAuto += itemMeses+ (itemAnos * 12);
        }); 
        console.log("chau  sumaMesesAuto " + sumaMesesAuto + ' mDepe_aux ' + mDepe_aux + " aDepe_aux " + aDepe_aux + " mCoin_aux " + mCoin_aux + " aCoin_aux " + aCoin_aux)
        if(regi_aux == "ambos"){
          sumaMesesAuto += mDepe_aux
          sumaMesesAuto += aDepe_aux * 12
          sumaMesesAuto -= mCoin_aux
          sumaMesesAuto -= (aCoin_aux * 12)
        }
        console.log("regi[_aux " + regi_aux +  " sumaMesesAuto " + sumaMesesAuto + " ")
        aniosAporteAux_ = parseInt(sumaMesesAuto / 12);
        if(sumaMesesAuto % 12 > 6){
          aniosAporteAux_ += 1;
        }    
      }
      /////

      /////


      faltante = minimoAniosAporte - aniosAporteAux_;
      if(eValue && typeof eValue != "undefined"){
        if(faltante >= 0){
          edadRetiroAux = eValue + faltante;
        }
        else{
          edadRetiroAux = eValue;
        }
      }
      else{
        if(faltante >= 0){
          edadRetiroAux = edad + faltante;
        }
        else{
          edadRetiroAux = edad;
        }

      }

      
      setAniosAporteAux(aniosAporteAux_)
      
      if (edadRetiroAux < 0){
        edadRetiroAux = 0;
      }
      console.log("__ edadRetiroAux " + edadRetiroAux + " edadRetiro " + edadRetiro + " edad " + edad + " faltante " + faltante + "aniosAporteAux_ " + aniosAporteAux_ + " aniosAporte " + aniosAporte + " minimoAniosAporte " + minimoAniosAporte + "mesesAPorte " + mesesAporte + " sexo_aux " + sexo_aux + " edadretirom " + edadRetiroM + " edadRetiroF " + edadRetiroF + "sValue " + sValue)
      if(sexo_aux.toUpperCase() =='M'){
        if(edadRetiroAux > edadRetiroM){
          console.log("mvalue******SETEDADRETIRO*******482*********" + edadRetiroAux + " edad " + edad + " faltante " + faltante + " minimoAniosAporte " + minimoAniosAporte + " aniosAporteAux_ " + aniosAporteAux_ + " aniosAporte " + aniosAporte)
          setEdadRetiro(edadRetiroAux)  
        }
        else{
          // console.log("******SETEDADRETIRO*******486*********" + edadRetiroM)
          setEdadRetiro(edadRetiroM)
        }
      }
      else{
        if(edadRetiroAux > edadRetiroF){
          // console.log("******SETEDADRETIRO*******497*********" + edadRetiroAux)
          setEdadRetiro(edadRetiroAux)  
        }
        else{
          // console.log("******SETEDADRETIRO*******501*********" + edadRetiroF)
          setEdadRetiro(edadRetiroF)
        }
      }
    }

    //INSERTAR
    function addData() {
      if(categoriaValue && categoriaValue != "" && typeof categoriaValue != "undefined"){
        

        console.log("Funcion addData - variable anos")
        console.log(anos)
        console.log(categoriaValue)						 
        //delete registro.id;
        const newData = [{   
          id:uuidv4(),     
          letra: letra,
          anos: anos,
          meses: meses,
          ultimacategoria: ultimacategoria,
          categoriaValue: categoriaValue							  
        }]

        console.log("Funcion addData - objeto newData")
        console.log(newData)

        setData(data.concat(newData))     
        console.log("Funcion addData - objeto data despues de concatenar")
        console.log(data)
        

        calcularRetiro(null, null, null, null, data.concat(newData), null, null, null, null, null)
      }
      setErrorTable(false)
      setMeses(null)
      setCategoria(null)
      setCategoriaValue("")   
      setAnos(null)
      abrirCerrarModalInsertar();
      form.resetFields()  
    }

  //EDITAR
  function editarRegistro(){
    console.log("entra en editarRegistro()")
    var dataAuxiliar = data;
    console.log("dataAuxiliar");
    console.log(dataAuxiliar);
    dataAuxiliar.map(elemento =>{
      
        if(elemento.id===registro.id){
          console.log("entra para actualizar")
            elemento.letra=registro.letra;
            elemento.anos=registro.anos;
            elemento.meses=registro.meses;
            elemento.ultimacategoria = registro.ultimacategoria;
			elemento.categoriaValue = registro.categoriaValue;												  
        }
        
    });
    setData(dataAuxiliar);
    abrirCerrarModalEditar();
  }
  
  
  //DELETE - Eliminar
  const peticionDelete = async() => {    
        setData(data.filter(elemento=>elemento.id!==registro.id));
        abrirCerrarModalEliminar();
        setErrorTable(false)
        calcularRetiro(null, null, null, null, data.filter(elemento=>elemento.id!==registro.id), null, null, null, null, null)
}  


  function handleChangeCategoria(value) {      
    console.log("Value")
    console.log(value)
    let letraCategoria = '';
    switch(value) {
      case "1":
        letraCategoria = 'I';
        break;
      case "2":
        letraCategoria = 'II';
        break;
      case "3":
        letraCategoria = 'III';
        break;
      case "4":
        letraCategoria = 'IV';
        break;
      case "5":
        letraCategoria = 'V';
        break;      
      default:
        letraCategoria = value;
    }
    setCategoria(letraCategoria)

	setCategoriaValue(value) 
  }

  function handleChangeUltimaCategoria(e) {  
    console.log("entra en handleChangeUltimaCategoria")
    console.log(e.target.value)   
    setUltimacategoria(e.target.value)
  }

  function handleChangeAnos(value) {      
    setAnos(value)
  }

  function handleChangeMeses(value) {     
    setMeses(value)
  }

  function handleChangeCategoriaE(value){
    console.log("entra en handleChangeCategoria")
    console.log(value)
    let letraCategoria = '';
    switch(value) {
      case "1":
        letraCategoria = 'I';
        break;
      case "2":
        letraCategoria = 'II';
        break;
      case "3":
        letraCategoria = 'III';
        break;
      case "4":
        letraCategoria = 'IV';
        break;
      case "5":
        letraCategoria = 'V';
        break;      
      default:
        letraCategoria = 'N/D'; 
    }   
    console.log(letraCategoria)
    setRegistro({...registro, letra: letraCategoria});
    setRegistro({...registro, categoriaValue: value});
    console.log("registro")
    console.log(registro)
}


  function handleChangeUltimaCategoriaE(e){
    console.log("entra en handleChangeUltimaCategoriaE")
    console.log(e.target.value)
    setRegistro({...registro, ultimacategoria: e.target.value});
    console.log(registro)
  }

  console.log(registro)

  function handleChangeMesesE(value){
    console.log("entra en handleChangeMeses")
    console.log(value)
    setRegistro({...registro, meses: value});
    console.log(registro)
  }

  function handleChangeAnosE(value){
    console.log("entra en handleChangeAnos")
    console.log(value)
    setRegistro({...registro, anos: value});
    console.log(registro)
  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }

  function eliminarRegistro (){
    console.log("entra en funcion eliminarRegistro")
    
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  function disabledDate(current) {
    // no puede seleccionar una fecha de nacimiento superior a la fecha de calculo    
    return current && current > fCalc;
  }

  function capturarAniosAporte(value){
    console.log("*aporte anios " + value);
    setAniosAporte(value);
    console.log("*anios aporte " + aniosAporte)
    calcularRetiro(value, null, null, null, null, null, null, null, null, null)
  }

    
  const capturarInfo = async() => {
    await axios.get('https://a3l.com.ar/Cotizador/Backend/DatosInfo/EXPLICACION_')
    .then(response=>{
      setInfoEM10(response.data.infoEM10);
      setInfoRM10(response.data.infoRM10);
      setInfoERet(response.data.infoERet);
      setInfoUltCat(response.data.infoUltCat);
    }).catch(error=>{
        console.log(error);
    })


    await axios.get('https://a3l.com.ar/Cotizador/Backend/DatosRetiro')
    .then(response=>{
      setEdadRetiroM(response.data.edadRetiroM);
      seteEdadRetiroF(response.data.edadRetiroF);
      // setMinimoAniosAporte(response.data.minimoAniosAporte);
 
      setMinimoAniosAporte(response.data.minimoAniosAporte);
     
      // alert("minimo " + response.data.minimoAniosAporte)
      // if(sexo.toUpperCase() == 'M'){
      //   setEdadRetiro(response.data.edadRetiroM)
      // }
      // else{
      //   setEdadRetiro(response.data.edadRetiroF)
      // }
      
    }).catch(error=>{
        console.log(error);
    })

}


  function capturarAniosIAporte(value){
    console.log("aporte anios Independiente " + value);
    setAniosIAporte(value);
    console.log("anios aporte Independiente " + aniosIAporte)
    calcularRetiro(null, null, null, null, null, null, value, null, null, null) 
  }
  
  function capturarAniosAAporte(value){
    console.log("aporte anios Ambos " + value);
    setAniosAAporte(value);
    console.log("anios aporte Ambos " + aniosAAporte)
    calcularRetiro(null, null, null, null, null, null, null, null, value, null)
  }

  function capturarMesesAporte(value){
    console.log("aporte anios Ambos " + value);
    setMesesAporte(value);
    console.log("anios aporte Ambos " + mesesAporte)
    calcularRetiro(null, value, null, null, null, null, null, null, null, null)
 
  }
  
  function capturarMesesIAporte(value){
    console.log("aporte anios Ambos " + value);
    setMesesIAporte(value);
    console.log("anios aporte Ambos " + mesesIAporte)
    calcularRetiro(null, null, null, null, null, null, null, value, null, null)
  }
  
  function capturarMesesAAporte(value){
    console.log("aporte anios Ambos " + value);
    setMesesAAporte(value);
    console.log("anios aporte Ambos " + mesesAAporte)
    calcularRetiro(null, null, null, null, null, null, null, null, null, value)
  }

  // FIN - FUNCIONES
    
  return (

    <div className="body1">

    <br/>

     <Row>
        <Col xs={1}  sm={1}  md={2}  lg={3} ></Col>

        <Col xs={22} sm={22} md={20} lg={18} >
        
                

          <Form name="formulario" onFinish={formSuccess} onFinishFailed={formFailed} {...layout} initialValues={{  fechaCalculo: moment() }}>                                                  
        
            <div className="formContainer">

              <Item
                  name="nombre"
                  label="Nombre y apellido"
                  
                  hasFeedback                
              rules={[
                {
                  required:true,
                  message:"Por favor ingrese su nombre y apellido",                    
                }
              ]}>
                  <Input placeholder = "Ingrese su Nombre completo"    />
            </Item>
            <Item
                  name="documento"
                  label="CUIT/CUIL"                   
                  hasFeedback                 
              rules={[
                {
                  required:true,
                  message:"Por favor ingrese el CUIT/CUIL",                    
                },{
                  pattern: /^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/g,
                  message: 'Por favor ingrese un CUIT/CUIL válido, Ejemplos: 20123456781 o 20-12345678-1',
              }
              ]}>
                  <Input placeholder = "20123456781 o 20-12345678-1"  />
            </Item>

              <Item
                name = "mail"                                 
                label="Correo electrónico"                
                hasFeedback                
                rules={[
                  {
                    required:true,
                    message:"Por favor ingrese su correo electrónico correctamente",                    
                    type: 'email'
                  }
                ]}
              >
                    <Input  placeholder = "Ingrese su correo electrónico"  />
              </Item>

              <Item 
              name="regimen"
                label="Régimen" 
                hasFeedback
                rules={[{
                  required:true,
                  message:"Por favor ingrese su régimen"}]
                }>
                  <Select 
                    
                    placeholder="Seleccionar"
                    onChange={onChange}                    
                    >                    
                      <Option value="depe">Dependiente  </Option>
                      <Option value="auto">Autónomo </Option>
                      <Option value="ambos">Ambos</Option>
                  </Select> 
              </Item>   

              { regimen != null ?
                    <div>
                      
                      <Item 
                          name="fechaCalculo" 
                          label="Fecha de calculo"
                          hasFeedback                                            
                          rules={[{
                            required:true,
                            message:"Por favor ingrese la fecha de cálculo"}]}                  
                           

                        > 
                          <DatePicker 
                            style={{ width: '100%' }}
                            locale={locale}
                            format={dateFormat}
                            onChange={fechaCalculo}
                            placeholder = "DD/MM/AAAA"
                          /> 

                      </Item>

                      
                      <Item 
                        name="fechaNacim" 
                        label="Fecha de nacimiento"                          
                        hasFeedback
                        rules={[
                          {
                          required:true,
                          message:"Por favor ingrese la fecha de nacimiento"},                          
                        ]}                                
                        > 

                          <DatePicker 
                            style={{ width: '100%' }} 
                            locale={locale}
                            onChange={cumple}
                            format={dateFormat}
                            placeholder = "DD/MM/AAAA"
                            disabledDate={disabledDate}
                            /> 

                      </Item>
                      

                      <Item 
                        name="sexo" 
                        label="Sexo"  
                        hasFeedback                       
                        rules={[{
                          required:true,
                          
                          message:"Por favor seleccione su sexo "}]}> 
                          
                          <Radio.Group                             
                          
                          onChange={calculadoraDeAnios}
                            buttonStyle="solid" 
                            style={{ width: '100%' }} 
                            >
                              <Radio.Button style={{ width: '50%' }}  value="m">Masculino</Radio.Button> 
                              <Radio.Button style={{ width: '50%' }}  value="f">Femenino</Radio.Button>
                          </Radio.Group> 
                      </Item>
                      
                        
                      {regimen === "depe"  && nacimiento ?
                        <Item label = "Años de aporte" style={{ marginBottom: 0 }}>
                          <Item 
                            name = "aniosAporteTotales" 
                            hasFeedback                                                     
                            rules = {[{required: mesesAporte > 0 ? false : true,message:"Por favor ingrese los Años"}]}
                            style={{ display: 'inline-block', width: 'calc(50% - 50px)' }} 
                            > 
                              <InputNumber 
                                onChange={capturarAniosAporte}
                                min={0} 
                                max={100}                                 
                                name='AporteAños'                                 
                                style={{width:"100%"}}                             
                              ></InputNumber>                               
                          </Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '45px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Año/s
                          </span>
                          <Item 
                            name = "mesesAporteTotales"                                                     
                            rules = {[{required: aniosAporte > 0 ? false : true, message:"Por favor ingrese los Meses"}]}
                            style = {{ display: 'inline-block', width: 'calc(50% - 60px)', margin: '0 0 0px 10px'}}
                            hasFeedback                           
                            >                               
                              <InputNumber 
                                onChange={capturarMesesAporte}                              
                                min={0} 
                                max={11}
                                initialValues={0}
                                value={0}
                                style={{ width: '100%' }}   
                                name='AporteMeses'
                                ></InputNumber> 
                          </Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '55px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Mes/es
                          </span>

                        </Item>

                      : "" }

                      { regimen === "ambos" && nacimiento ?
                        
                        <Item label="Años de aporte en Rel. Dep"  style={{ marginBottom: 0 }}>

                          <Item 
                            name="aniosAporteRelacion"                             
                            rules={[{required:mesesIAporte > 0 ? false : true,message:"Año es requerido"}]}
                            hasFeedback
                            style={{ display: 'inline-block', width: 'calc(50% - 50px)' }}
                            >                           
                              <InputNumber 
                                onChange={capturarAniosIAporte} 
                                min={0} 
                                max={65}   
                                style={{ width: '100%'}}   
                                name='AporteIAños'                                
                                ></InputNumber> 
                          </Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '45px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Año/s
                          </span>
                          <Item 
                            name="mesesAporteRelacion"                              
                            rules={[{required:aniosIAporte > 0 ? false : true,message:"Mes es requerido"}]}
                            style={{ display: 'inline-block', width: 'calc(50% - 60px)', margin: '0 0 0px 10px' }} 
                            hasFeedback
                            > 
                              <InputNumber
                                onChange={capturarMesesIAporte}                                
                                min={0} 
                                max={11}  
                                style={{ width: '100%' }} 
                                initialValues={0}
                                name='AporteIMeses'                               
                              ></InputNumber>                               
                          </Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '55px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Mes/es
                          </span>
                          { errorTotales === true ?
                            <div style={{ marginBottom: '24px', marginTop:"-18px" }} > 
                              <Text type="danger">Los años de relación de dependencia no pueden superar a los años totales</Text>
                            </div>
                          :""}                          
                        </Item> 

                      : "" }

                      { regimen === "ambos" && nacimiento?
                        <Item label="Años de aporte simultáneos" style={{ marginBottom: 0 }} >
                            <Item 
                              name="aniosAporteCoincidentes"                                
                              //rules={[{required:mesesAAporte > 0 ? false : true,message:"Por favor ingrese los Años"}]}
                              style={{ display: 'inline-block', width: 'calc(50% - 50px)' }} 
                              suffix="Años"
                              hasFeedback
                              > 
                                <InputNumber 
                                  onChange={capturarAniosAAporte}
                                  min={0} 
                                  max={65}  
                                  style={{ width: '100%' }}   
                                  name='AporteAAños'                                 
                                ></InputNumber>                             
                            </Item>
                            <span
                            style={{
                              display: 'inline-block',
                              width: '45px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Año/s
                          </span>                            

                            <Item 
                              name="mesesAporteCoincidentes"                               
                              //rules={[{required:aniosAAporte > 0 ? false : true,message:"Por favor ingrese los Meses"}]}
                              style={{ display: 'inline-block', width: 'calc(50% - 60px)', margin: '0 0 0px 10px' }} 
                              suffix="Meses" 
                              hasFeedback
                              >
                                <InputNumber 
                                  onChange={capturarMesesAAporte} 
                                  min={0} 
                                  max={11}  
                                  style={{ width: '100%'}} 
                                  initialValues={0}
                                  name='AporteAMeses'                               
                                ></InputNumber> 
                            </Item>
                            <span
                            style={{
                              display: 'inline-block',
                              width: '55px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            Mes/es
                          </span>
                          { errorCoincidentes === true ?
                            <div style={{ marginBottom: '24px', marginTop:"-18px" }} > 
                              <Text type="danger">Debe ingresar Aportes coincidentes</Text>
                            </div>
                          :""}
                          { errorCoincidentes2 === true ?
                            <div style={{ marginBottom: '24px', marginTop:"-18px" }} > 
                              <Text type="danger">Los años coincidentes no pueden superar a los años totales</Text>
                            </div>
                          :""}     
                          { errorCoincidentes3 === true ?
                            <div style={{ marginBottom: '24px', marginTop:"-18px" }} > 
                              <Text type="danger">Los años de aportes como autónomo no pueden ser menores a los años de aporte simultáneos</Text>
                            </div>
                          :""}                                                       
                          </Item>

                      : "" }

                      { regimen === "auto" || regimen === "ambos" ?
                      <div style={{width:"100%", marginTop: "30px"}} >
                        
                        <div style={{margin: "0 auto", width:"100%"}}>
                          <Text >Complete los años de aporte en cada categoría</Text><br/> 
                              <Button 
                                style={{ marginBottom: 8 , marginTop: 8, backgroundColor:"#4caf50",background:"#4caf50", borderColor:"#4caf50", borderstyle: "none" }} 
                                type="primary" 
                                icon={<PlusOutlined />} 
                                onClick={abrirCerrarModalInsertar}
                              >
                                  AGREGAR
                              </Button>                          
                        </div>    

                            <Item {...layoutTable}>
                              <Table columns={columns} style={{ Width: '100%' }} dataSource={data} size="small" bordered pagination={false}/>
                            </Item>
                            { errorTable === true ?
                              <div style={{ marginBottom: '24px', marginTop:"-18px" }} > 
                                <Text type="danger">Por favor, ingrese todos los datos de la tabla de categorias</Text>
                              </div>
                            :""}
                            
                            {data.length > 1 ?
                            <Item name="ultimaCate" 
                              label="Última Categoria "   
                              tooltip={{ title: infoUltCat, icon: <InfoCircleOutlined /> }}
                              hasFeedback                 
                              rules={[
                                {
                                  required:true,
                                  message:"Por favor ingrese su última categoria",                    
                                }
                              ]}>
                              <Select placeholder="Ingrese su categoria actual o última" name="ultimaCate" >

                              

                              {data.map(item => (
                                      <Option value={item.categoriaValue}>{item.letra} </Option>
                                    ))}
                              </Select>   
                            </Item>
                          :""}
                        </div>
                      : "" }													 

                        </div>
                      : "" }

                      
                        <div>
                        { nacimiento != null && regimen != 'auto' && !(edad >= edadRetiro && aniosAporteAux >= minimoAniosAporte) ?
                          <Item 
                            name="ingActual" 
                            label="Ingresos actuales" 
                            hasFeedback                            
                            rules={[{required:true,message:"Por favor complete sus ingresos actuales "}]}> 
                              <InputNumber 
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}  
                                style={{ width: '100%'}}  
                                prefix="$" suffix="ARS" 
                                placeholder=' Ingresos' 
                                name='IngresoActual'/> 
                          </Item>
                           :""}
                           
                          { nacimiento != null && (regimen == 'depe' || ( regimen == 'ambos' && data.length > 0)) && edad >= edadRetiro && aniosAporteAux >= minimoAniosAporte && aniosAporteAux > 0 ?
                          
                          <Item 
                            name="IngEdadM10" 
                            hasFeedback
                            label= {ingresosMenos10 } 
                            rules={[{required:true,message:"Por favor complete este ingreso"}]}
                            tooltip={{ title: infoEM10, icon: <InfoCircleOutlined /> }}>
                              <InputNumber 
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}  
                                style={{ width: '100%'}}  
                                prefix="$" suffix="ARS" 
                                placeholder=' Ingresos' 
                                name='IngresoActualMenos10'/> 
                          </Item>
                          :""}
                              </div>
                      

                     
                        <div>
                         
                        { sexo != null  && (regimen == 'depe' || ( regimen == 'ambos' && data.length > 0)) &&  !(edad >= edadRetiro && aniosAporteAux >= minimoAniosAporte)   && aniosAporteAux > 0  ?
                          <Item 
                            name="IngEdadRetM10" 
                            
                           label={ "Ingresos a los "+ (edadRetiro - 10) + " años"} 
                           
                           rules={[{required:true,message:"Por favor complete este ingreso"}]}
                            tooltip={{ title: infoRM10, icon: <InfoCircleOutlined /> }}
                            hasFeedback> 
                            
                              <InputNumber 
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}  
                                style={{ width: '100%'}}  
                                prefix="$" suffix="ARS" 
                                placeholder=' Ingresos' 
                                name='Ingreso55'/>
                          </Item>
                        :""} 
                         { sexo != null  && (regimen == 'depe' || ( regimen == 'ambos' && data.length > 0))  && aniosAporteAux > 0  ?
                          <Item 
                            name="IngEdadRet" 
                            
                            label= {(edad >= edadRetiro && aniosAporteAux >= minimoAniosAporte) ? "Ingresos Actuales ": "Ingresos a los " + edadRetiro + " años"}
                            rules={[{required:true,message:"Por favor complete este ingreso"}]}
                            tooltip={{ title: infoERet, icon: <InfoCircleOutlined /> }}
                            hasFeedback> 
                              <InputNumber 
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}  
                                style={{ width: '100%'}}  
                                prefix="$" suffix="ARS" 
                                placeholder=' Ingresos' 
                                name='Ingreso55'/>
                          </Item>
                          :""}
                        </div>
                       

                    </div>       
              
            
              
              <div style={{width:"100%"}}>
                <div style={{margin: "0 auto", width:"118px"}}>
                  <br/>
                <Button 
                  name="botoncotizar" 
                  size="large"
                  type="primary"                   
                  htmlType="submit"
                  loading={loading}
                  >                  
                    COTIZAR {<SendOutlined/>}
                </Button>
                </div><br/>
              </div> 

          </Form>

          {/* <h1>Has seleccionado: {regimen}</h1> */}
          
        </Col>

        <Col xs={1}  sm={1}  md={2}  lg={6} ></Col>
     </Row>
          
          {/*MODAL - INSERTAR*/}
          <Modal
            visible={modalInsertar}
            title="Agregar categoria"
            destroyOnClose={true}
            onCancel={abrirCerrarModalInsertar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalInsertar}>Cancelar</Button>,
                    <Button onClick={addData} type="submit">Insertar</Button>
                ]}
            onOk={() => {
              form.validateFields()
              }
            }    
            >

                <Form {...layoutModal} form={form} name="form_in_modal" >

                    <Item name="letra" 
                      initialValue={null}
                      label="Categoria" 
                      hasFeedback                 
                      rules={[
                        {
                          required:true,
                          message:"Por favor ingrese una categoria",                    
                        }
                      ]}>
                      <Select rules={[
                        {
                          required:true,
                          message:"Por favor ingrese una categoria",                    
                        }
                      ]} placeholder="Categoria de autónomo" name="letra" 
                      
                      onChange={handleChangeCategoria}
                      >
                      {
                     
                        data.forEach(function (item) {
                          if(item.categoriaValue == "1"){
                            hayCat1 = true
                          }
                          if(item.categoriaValue == "2"){
                            hayCat2 = true
                          }
                          if(item.categoriaValue == "3"){
                            hayCat3 = true
                          }
                          if(item.categoriaValue == "4"){
                            hayCat4 = true
                          }
                          if(item.categoriaValue == "5"){
                            hayCat5 = true
                          }
                          
                          if(item.categoriaValue == "A"){
                            hayCatA = true
                          }
                          if(item.categoriaValue == "B"){
                            hayCatB = true
                          }
                          if(item.categoriaValue == "C"){
                            hayCatC = true
                          }
                          if(item.categoriaValue == "D"){
                            hayCatD = true
                          }
                          if(item.categoriaValue == "E"){
                            hayCatE = true
                          }
                          if(item.categoriaValue == "F"){
                            hayCatF = true
                          }
                          if(item.categoriaValue == "G"){
                            hayCatG = true
                          }
                          if(item.categoriaValue == "H"){
                            hayCatH = true
                          }
                          if(item.categoriaValue == "I"){
                            hayCatI = true
                          }
                          if(item.categoriaValue == "J"){
                            hayCatJ = true
                          }               
                          if(item.categoriaValue == "W"){
                            hayCatW = true
                          }                                         
                        })

                      }

                        {hayCat1 == false ? <Option value="1">I  </Option> : ""}
                        {hayCat2 == false ? <Option value="2">II  </Option> : ""}
                        {hayCat3 == false ? <Option value="3">III  </Option> : ""}
                        {hayCat4 == false ? <Option value="4">IV  </Option> : ""}
                        {hayCat5 == false ? <Option value="5">V  </Option> : ""}
                        
                        {hayCatA == false ? <Option value="A">A  </Option> : ""}
                        {hayCatB == false ? <Option value="B">B  </Option> : ""}
                        {hayCatC == false ? <Option value="C">C  </Option> : ""}
                        {hayCatD == false ? <Option value="D">D  </Option> : ""}
                        {hayCatE == false ? <Option value="E">E  </Option> : ""}
                        {hayCatF == false ? <Option value="F">F  </Option> : ""}
                        {hayCatG == false ? <Option value="G">G  </Option> : ""}
                        {hayCatH == false ? <Option value="H">H  </Option> : ""}
                        {hayCatI == false ? <Option value="I">I  </Option> : ""}
                        {hayCatJ == false ? <Option value="J">J  </Option> : ""}
                        {hayCatW == false ? <Option value="W">W  </Option> : ""}
                      </Select>   
                    </Item>

                    <Item label="Años" 
                    initialValue={null}>
                      <InputNumber 
                      initialValue={null}
                        placeholder='Años' 
                        name="anos" 
                        onChange={handleChangeAnos}  
                        min={0} 
                        hasFeedback                 
                        rules={[
                          {
                            required:true,
                            message:"Por favor ingrese la cantidad de años",                    
                          }
                        ]}>                                                
                        </InputNumber>
                    </Item>

                    <Item label="Meses" 
                      initialValue={null}
                      hasFeedback                 
                      rules={[
                        {
                          required:true,
                          message:"Por favor ingrese la cantidad de meses",                    
                        }
                      ]}>
                      <InputNumber
                        initialValue={null}
                        placeholder='Meses' 
                        name="meses" 
                        onChange={handleChangeMeses} 
                        min={0} 
                        max={11}                         
                        ></InputNumber>
                    </Item>


                    {/*<Item 
                        label="Última categoria?"
                        hasFeedback                 
                        rules={[
                          {
                            required:true,
                            message:"Por favor especifique si es su última categoria o no",                    
                          }
                        ]}>
                          <Radio.Group                             
                            onChange={handleChangeUltimaCategoria}
                            buttonStyle="solid">
                              <Radio.Button  value="Si">Si</Radio.Button> 
                              <Radio.Button  value="No">No</Radio.Button>
                          </Radio.Group> 
                    </Item>*/}

                </Form>

          </Modal>


          {/*MODAL - UPDATE*/}
          <Modal
            visible={modalEditar}
            title="Editar categoria"
            onCancel={abrirCerrarModalEditar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalEditar}>Cancelar</Button>,
                    <Button type="primary" onClick={editarRegistro}>Confirmar</Button>
                ]}
          >

              <Form {...layoutModal}>
                  <Item label="Categoria">
                      <Select name="letra" onChange={handleChangeCategoriaE} value={registro && registro.letra}  >
                          <Option value="1">I  </Option>
                          <Option value="2">II </Option>
                          <Option value="3">III</Option>
                          <Option value="4">IV </Option>
                          <Option value="5">V  </Option>
                          <Option value="A">A  </Option>
                          <Option value="B">B  </Option>
                          <Option value="C">C  </Option>
                          <Option value="D">D  </Option>
                          <Option value="E">E  </Option>
                          <Option value="F">F  </Option>
                          <Option value="G">G  </Option>
                          <Option value="H">H  </Option>
                          <Option value="I">I  </Option>
                          <Option value="J">J  </Option>
                          <Option value="W">W  </Option>
                      </Select>
                  </Item>

                  <Item label="Años">
                      <InputNumber 
                        name="anos" 
                        onChange={handleChangeAnosE} 
                        value={registro && registro.anos} 
                        min={0}                         
                        ></InputNumber>
                  </Item>

                  <Item label="Meses">
                      <InputNumber 
                        name="meses" 
                        onChange={handleChangeMesesE} 
                        value={registro && registro.meses} 
                        min={0} 
                        max={11} 
                        ></InputNumber>                        
                  </Item>              

                  <Item 
                      label="Última categoria?"> 
                        <Radio.Group                             
                          onChange={handleChangeUltimaCategoriaE}
                          buttonStyle="solid"
                          value={registro && registro.ultimacategoria}>
                            <Radio.Button  value="Si">Si</Radio.Button> 
                            <Radio.Button  value="No">No</Radio.Button>
                        </Radio.Group> 
                  </Item>
              </Form>

          </Modal>  


                        {/*MODAL - ELIMINAR*/}
            <Modal
            visible={modalEliminar}
            onCancel={abrirCerrarModalEliminar}
            centered
            footer={
                [
                    <Button onClick={abrirCerrarModalEliminar}>No</Button>,
                    <Button type="primary" danger onClick={peticionDelete}>Si</Button>
                ]}
            >

                Estas seguro que desea eliminar la categoria <b>{registro && registro.letra}</b> ?

            </Modal>                     
            <Helmet>
              <script src="iframeResizer.contentWindow.min.js" type="text/javascript" />
            </Helmet>
    </div>
  

);}

export default App;